import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';


@Component({ template: '' })
export class ConfiguradorReturnComponent implements OnInit{
  // constructor(private route: ActivatedRoute){}

  ngOnInit(){
    const returnUrl = new URL(window.location.href);
    const configurationProcess =
              returnUrl.searchParams.get('configuration_process');
          const seatCode =
              returnUrl.searchParams.get('audicode');
    const params = {
      configurationProcess,
      seatCode
    };
    console.log('ENTRO EN EL RELAY',  params ,' ===> ',window.location.origin , ' ==> ', window.parent);
    if(window.parent !== window){
      window.parent.postMessage({
        type:'IFRAME_STEP_COMPLETE',payload:params},window.location.origin);
    }
  }

}
